<template>
  <div>
    <StepHeader title="What Is Your Estimated Credit Rating?"/>
    <StepContent
      width="xl"
    >
      <AppButtonList
        :columns="3"
        :buttons="buttons"
        :value="credit_rating"
        @input="handleClick($event)"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        v-data-layer="handleDataLayer"
        @click="$emit('next')"
      >
        Continue
      </AppButtonContinue>

      <StepTooltip>
        Get the best rate possible, regardless of your credit score.
      </StepTooltip>
    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'
import StepTooltip from '@/components/common/step/StepTooltip'
import DataLayer from '../../../../data-layer'

export default {
  // Name
  name: 'credit-rating',

  // Components
  components: {
    AppButtonContinue,
    AppButtonList,
    StepContent,
    StepFooter,
    StepHeader,
    StepTooltip
  },

  // Data
  data () {
    return {
      datalayerStepName: 'credit_rating',
      fieldName: 'credit_rating',
      defaultSelected: true,
      buttons: [{
        text: 'Good (Over 650)',
        value: 'Good (650 +)',
        datalayer: 'good'
      }, {
        text: 'Fair (550-650)',
        value: 'Fair (550 - 649)',
        datalayer: 'fair'
      }, {
        text: 'Poor (Under 550)',
        value: 'Poor (400 - 549)',
        datalayer: 'poor'
      }, {
        text: 'Current Bankruptcy',
        value: 'Current Bankruptcy',
        datalayer: 'bankruptcy'
      }, {
        text: 'No Credit / Unsure',
        value: 'No Credit',
        datalayer: 'nocredit'
      }]
    }
  },

  // Computed
  computed: {
    credit_rating () {
      return this.$store.state.application[this.fieldName]
    }
  },

  // Created
  created () {
    if (!this.credit_rating) {
      this.$store.updateApplication(
        this.fieldName,
        this.buttons[0].value
      )
    } else {
      this.defaultSelected = false
    }
  },

  // Methods
  methods: {
    handleClick (event) {
      this.$store.updateApplication(this.fieldName, event)
      this.defaultSelected = false
    },
    handleDataLayer () {
      DataLayer.track({
        event: 'gpa_step_completed',
        step: '5',
        estimated_credit_rating: this.credit_rating
      })
    }
  }
}
</script>

<style>
</style>
